import { createStore } from 'vuex'

export default createStore({
  state: {
    userinfo:{
      
    },
    hasLogin:false
  },
  getters: {
  },
  mutations: {
    set_userinfo(state,val){
      state.hasLogin = true
      state.userinfo = val
    }
  },
  actions: {
  },
  modules: {
  }
})
